
























import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import HomeOverviewCampaign from '@/componentsV2/molecules/HomeOverviewCampaign/HomeOverviewCampaign.vue';

import OfferItem from '@/components/organisms/Offers/DataPresentation/OfferItem.vue';
import WelcomeCoinsItem from '@/componentsV2/molecules/HomeOverviewCampaign/WelcomeCoinsItem.vue';
import ReferralItem from '@/componentsV2/molecules/HomeOverviewCampaign/ReferralItem.vue';
import SellCoinsItem from '@/componentsV2/molecules/HomeOverviewCampaign/SellCoinsItem.vue';
import ProgramStatusItem from '@/componentsV2/molecules/HomeOverviewCampaign/ProgramStatusItem.vue';
import SocialRewardsItem from '@/componentsV2/molecules/HomeOverviewCampaign/SocialRewardsItem.vue';
import EmailAutomationItem from '@/componentsV2/molecules/HomeOverviewCampaign/EmailAutomationItem.vue';

import SpecialCoinOffersService from '@/api/SpecialCoinOffersService';
import OfferFreeCoinsService from '@/api/OfferFreeCoinsService';
import ReferralService from '@/api/ReferralService';
import SellCoinsService from '@/api/SellCoinsService';
import BillingModel from '@/views/Models/BillingModel.vue';
import SocialRewardsService from '@/api/SocialRewardsService';
import ActivationEmailService from '@/api/ActivationEmailService';

@Component({
  components: {
    Typography,
    HomeOverviewCampaign,
    OfferItem,
    WelcomeCoinsItem,
    ReferralItem,
    SellCoinsItem,
    ProgramStatusItem,
    SocialRewardsItem,
    EmailAutomationItem
  }
})
export default class HomeOverview extends Vue {
  @Prop() overviewData?: any;
  @Prop() campaigns?: any[];

  activationEmailService = new ActivationEmailService();
  socialRewardService = new SocialRewardsService();
  offerService = new SpecialCoinOffersService();
  freeCoinsService: OfferFreeCoinsService = new OfferFreeCoinsService();
  referralService = new ReferralService();
  sellCoinsService = new SellCoinsService();

  get campaignsProps(): any {
    return {
      programStatus: {
        component: 'ProgramStatusItem',
        title: 'Program status'
      },
      offer: {
        component: 'OfferItem',
        title: 'Active offers overview',
        seeAllText: 'See all my offers',
        btnText: 'Create new offer',
        clickSeeAll: () => {
          this.$router.push('/special-coins-offers');
        },
        click: () => {
          this.$router.push('/special-coins-offers/create');
        }
      },
      welcomeCoins: {
        component: 'WelcomeCoinsItem',
        title: 'Active Welcome Coin overview',
        seeAllText: 'See all my campaigns',
        btnText: 'Create new campaign',
        clickSeeAll: () => {
          this.$router.push('/marketing-center/offer-free-coins');
        },
        click: () => {
          this.$router.push('/marketing-center/offer-free-coins/create');
        }
      },
      referral: {
        component: 'ReferralItem',
        title: 'Referral overview',
        seeAllText: this.$mobileCheck() ? '' : 'See full campaign',
        btnText: 'Edit Program Settings',
        showPlusIcon: false,
        clickSeeAll: () => {
          this.$router.push('/referral-program');
        },
        click: () => {
          this.$router.push('/referral-program/edit');
        }
      },
      sellCoins: {
        component: 'SellCoinsItem',
        title: 'Active Sell Coins campaign overview',
        seeAllText: 'See all my campaigns',
        btnText: 'Create new campaign',
        clickSeeAll: () => {
          this.$router.push('/sell-coins');
        },
        click: () => {
          this.$router.push('/sell-coins/campaign/create');
        }
      },
      socialRewards: {
        component: 'SocialRewardsItem',
        title: 'Active Social Rewards overview',
        seeAllText: 'See all my campaigns',
        btnText: 'Create new campaign',
        clickSeeAll: () => {
          this.$router.push('/social-rewards');
        },
        click: () => {
          this.$router.push('/social-rewards');
        }
      },
      emailAutomation: {
        component: 'EmailAutomationItem',
        title: 'Active Email Automation overview'
      }
    };
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get programStatus() {
    return this.$store.getters['business/getRewardStatus'] || {};
  }

  formatCampaignToComponent(name: string) {
    return this.campaignsProps[name].component;
  }
}
